import React, { useEffect, useState, useRef } from "react";
import apiInstance from "../../utils/axios";
import UserData from "../plugin/UserData";
import { useParams, Link } from "react-router-dom";
import moment from 'moment';
import './style/customer-dashboard.css';
import PriceFormat_Basic from '@/components/commerce-ui/price-format-basic';

function Invoice() {
  const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [storeInfo, setStoreInfo] = useState({
    store_name: 'Herramientas Tayrun',
    phones: ['+595 981 123456'],
    emails: ['contacto@herramientastayrun.com.py'],
    address: 'Asunción, Paraguay'
  });

  const userData = UserData();
  const printRef = useRef();

  const param = useParams();

  // Fetch store info
  useEffect(() => {
    const fetchStoreInfo = async () => {
      try {
        const response = await apiInstance.get('store-info/');
        setStoreInfo(response.data);
      } catch (error) {
        console.log('Using default store info');
      }
    };
    fetchStoreInfo();
  }, []);

  useEffect(() => {
    if (userData?.user_id && param.order_oid) {
      setLoading(true);
      apiInstance.get(`customer/order/${userData.user_id}/${param.order_oid}/`)
        .then((res) => {
          setOrder(res.data);
          setOrderItems(res.data.orderitem || []);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching order:', error);
          setError("Error al cargar los detalles de la factura");
          setLoading(false);
        });
    }
  }, [userData?.user_id, param.order_oid]);

  const handlePrint = () => {
    const printContent = printRef.current;
    if (printContent) {
      const originalContent = document.body.innerHTML;
      document.body.innerHTML = printContent.innerHTML;
      window.print();
      document.body.innerHTML = originalContent;
      window.location.reload();
    }
  };

  if (loading) {
    return (
      <div className="customer-dashboard">
        <div className="container text-center py-5">
          <div className="spinner-border loading-spinner" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
                          <p className="mt-3">Cargando factura...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="customer-dashboard">
        <div className="container text-center py-5">
          <div className="alert alert-danger error-alert" role="alert">
            <i className="fas fa-exclamation-triangle me-2"></i>
            {error}
          </div>
          <Link to="/customer/orders/" className="btn btn-primary mt-3">
            <i className="fas fa-arrow-left me-2"></i> Volver a Pedidos
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="customer-dashboard">
      <main className="mt-4 mt-md-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-12 d-md-none">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="mb-0">
                  <i className="fas fa-file-invoice text-primary" /> Factura #{order.oid}
                </h3>
                <Link to="/customer/orders/" className="btn btn-outline-secondary btn-sm">
                  <i className="fas fa-arrow-left me-2"></i> Volver
                </Link>
              </div>
            </div>

            <div className="col-12">
              <div className="d-none d-md-flex justify-content-between align-items-center mb-4">
                <h3 className="mb-0">
                  <i className="fas fa-file-invoice text-primary" /> Factura #{order.oid}
                </h3>
                <div className="d-flex gap-2">
                  <Link to="/customer/orders/" className="btn btn-outline-secondary btn-sm">
                    <i className="fas fa-arrow-left me-2"></i> Volver a Pedidos
                  </Link>
                  <button onClick={handlePrint} className="btn btn-primary btn-sm">
                    <i className="fas fa-print me-2"></i> Imprimir Factura
                  </button>
                </div>
              </div>

              {/* Invoice Content */}
              <div ref={printRef} className="card border-0 shadow-sm depth-2">
                <div className="card-body p-4 p-md-5">
                  {/* Invoice Header */}
                  <div className="row mb-4">
                    <div className="col-12 col-md-6 mb-4 mb-md-0">
                      <div className="d-flex align-items-center mb-3">
                        <div className="d-flex align-items-center justify-content-center me-3" style={{ 
                          width: "60px", 
                          height: "60px", 
                          backgroundColor: "#e3f2fd", 
                          borderRadius: "12px" 
                        }}>
                          <i className="fas fa-store text-primary fs-3"></i>
                        </div>
                        <div>
                          <h4 className="mb-1 text-dark fw-bold">{storeInfo.store_name || 'Herramientas Tayrun'}<span className="text-warning">.</span></h4>
                          <p className="mb-1 text-muted small">
                            <i className="fas fa-phone me-2"></i>{storeInfo.phones?.[0] || '+595 981 123456'}
                          </p>
                          <p className="mb-1 text-muted small">
                            <i className="fas fa-envelope me-2"></i>{storeInfo.emails?.[0] || 'contacto@herramientastayrun.com.py'}
                          </p>
                          <p className="mb-0 text-muted small">
                            <i className="fas fa-location-arrow me-2"></i>{storeInfo.address || 'Asunción, Paraguay'}
                          </p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-12 col-md-6 text-md-end">
                      <div className="card border-0" style={{ backgroundColor: "#f8f9fa" }}>
                        <div className="card-body p-3">
                          <h6 className="mb-2 text-muted">FACTURA</h6>
                          <h4 className="mb-2 text-dark fw-bold">#{order.oid}</h4>
                          <p className="mb-1 text-muted small">
                            <strong>Fecha:</strong> {order.date ? moment(order.date).format('MMM DD, YYYY') : 'N/A'}
                          </p>
                          <p className="mb-0 text-muted small">
                            <strong>Fecha de Vencimiento:</strong> {order.date ? moment(order.date).format('MMM DD, YYYY') : 'N/A'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Customer Information */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="card border-0" style={{ backgroundColor: "#f8f9fa" }}>
                        <div className="card-body p-3">
                          <h6 className="mb-3 text-dark fw-semibold">
                            <i className="fas fa-user me-2 text-primary"></i>Facturar a
                          </h6>
                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <p className="mb-1"><strong>Nombre:</strong> {order.full_name || 'N/A'}</p>
                              <p className="mb-1"><strong>Email:</strong> {order.email || 'N/A'}</p>
                              <p className="mb-0"><strong>Teléfono:</strong> {order.phone || 'N/A'}</p>
                            </div>
                            <div className="col-12 col-sm-6">
                              <p className="mb-0"><strong>Dirección:</strong></p>
                              <p className="mb-0 text-muted">
                                {order.address}, {order.city}, {order.state}, {order.country}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Invoice Items Table */}
                  <div className="table-responsive mb-4">
                    <table className="table table-bordered mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th className="border-0 text-muted fw-semibold px-4 py-3">Producto</th>
                          <th className="border-0 text-muted fw-semibold px-4 py-3 text-center">Precio</th>
                          <th className="border-0 text-muted fw-semibold px-4 py-3 text-center">Cant.</th>
                          <th className="border-0 text-muted fw-semibold px-4 py-3 text-center">Subtotal</th>
                          <th className="border-0 text-muted fw-semibold px-4 py-3 text-center">Descuento</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderItems.length > 0 ? (
                          orderItems.map((item, index) => (
                            <tr key={index} className="border-bottom">
                              <td className="px-4 py-3">
                                <div className="d-flex align-items-center">
                                  <img
                                    src={item.product?.image}
                                    style={{ 
                                      width: "50px", 
                                      height: "50px", 
                                      objectFit: "cover", 
                                      borderRadius: "8px" 
                                    }}
                                    alt={(item.product?.title_translated || item.product?.title)}
                                    className="me-3"
                                  />
                                  <div>
                                    <p className="fw-semibold mb-1 text-dark">{item.product?.title_translated || item.product?.title}</p>
                                    {item.color && (
                                      <small className="text-muted">Color: {item.color}</small>
                                    )}
                                    {item.size && (
                                      <small className="text-muted ms-2">Tamaño: {item.size}</small>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td className="px-4 py-3 text-center">
                                <span className="fw-semibold"><PriceFormat_Basic value={item.price || 0} /></span>
                              </td>
                              <td className="px-4 py-3 text-center">
                                <span className="badge bg-light text-dark px-3 py-2">{item.qty}</span>
                              </td>
                              <td className="px-4 py-3 text-center">
                                <span className="fw-semibold"><PriceFormat_Basic value={item.sub_total || 0} /></span>
                              </td>
                              <td className="px-4 py-3 text-center">
                                <span className="text-success"><PriceFormat_Basic value={item.saved || 0} /></span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center py-5">
                              <div className="empty-state">
                                <div className="empty-state-icon">
                                  <i className="fas fa-box-open fa-2x"></i>
                                </div>
                                <h6 className="mb-2 text-dark">No se encontraron artículos</h6>
                                <p className="text-muted mb-0">Esta factura no tiene artículos.</p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Invoice Summary */}
                  <div className="row">
                    <div className="col-12 col-md-6 offset-md-6">
                      <div className="card border-0" style={{ backgroundColor: "#f8f9fa" }}>
                        <div className="card-body p-4">
                          <h6 className="mb-3 text-dark fw-semibold text-center">Resumen de Factura</h6>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Subtotal:</span>
                            <span className="fw-semibold"><PriceFormat_Basic value={order.sub_total || 0} /></span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Envío:</span>
                            <span className="fw-semibold"><PriceFormat_Basic value={order.shipping_ammount || 0} /></span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Impuesto:</span>
                            <span className="fw-semibold"><PriceFormat_Basic value={order.tax_fee || 0} /></span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Cargo por Servicio:</span>
                            <span className="fw-semibold"><PriceFormat_Basic value={order.service_fee || 0} /></span>
                          </div>
                          {order.saved && order.saved > 0 && (
                            <div className="d-flex justify-content-between mb-2">
                              <span className="text-success">Descuento</span>
                              <span className="fw-semibold text-success"><PriceFormat_Basic value={order.saved} prefix="-$" /></span>
                            </div>
                          )}
                          <hr />
                          <div className="d-flex justify-content-between">
                            <span className="fw-bold fs-5">Total:</span>
                            <span className="fw-bold fs-5 text-primary"><PriceFormat_Basic value={order.total || 0} /></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="row mt-4">
                    <div className="col-12 text-center">
                      <p className="text-muted small mb-0">
                        ¡Gracias por su compra! Esta es una factura generada por computadora.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mobile Print Button */}
              <div className="d-md-none mt-4 text-center">
                <button onClick={handlePrint} className="btn btn-primary btn-lg w-100">
                  <i className="fas fa-print me-2"></i> Imprimir Factura
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Invoice;
